/**
 * Date formatting utilities for consistent date/time handling
 */

/**
 * Formats a UTC timestamp to ISO format without milliseconds
 * @param timestamp - UTC timestamp as string (milliseconds since epoch)
 * @returns Formatted date string in format "YYYY-MM-DD HH:mm:ss"
 * 
 * @example
 * formatUTCTimestamp("1704067200000") // "2024-01-01 00:00:00"
 */
export const formatUTCTimestamp = (timestamp: string): string => {
  const date = new Date(parseInt(timestamp));
  return date.toISOString().replace("T", " ").replace(".000Z", "");
};

/**
 * Formats a Date object to ISO format for datetime-local input
 * @param date - Date object to format
 * @returns Formatted date string in format "YYYY-MM-DDTHH:mm"
 * 
 * @example
 * formatDateToInput(new Date("2024-01-01T12:30:00")) // "2024-01-01T12:30"
 */
export const formatDateToInput = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hours}:${minutes}`;
};
